import { Box, Button, FormHelperText, TextField } from '@material-ui/core'
import { Formik } from 'formik'
import type { FC } from 'react'
import * as Yup from 'yup'
import { authApi } from '../../api/authApi'
import useMounted from '../../hooks/useMounted'

const PasswordRecoveryEditForm: FC = (props) => {
    const mounted = useMounted()

    return (
        <Formik
            initialValues={{
                email: '',
                submit: null,
            }}
            validationSchema={Yup.object().shape({
                email: Yup.string()
                    .email('Keine gültige E-Mail')
                    .max(255)
                    .required('E-Mail ist erforderlich'),
            })}
            onSubmit={async (
                values,
                { setErrors, setStatus, setSubmitting }
            ): Promise<void> => {
                try {
                    await authApi.forgotPassword(values.email)

                    if (mounted.current) {
                        setStatus({ success: true })
                        setErrors({
                            submit: 'Bitte überprüfen Sie ihr Postfach',
                        })
                        setSubmitting(false)
                    }
                } catch (err) {
                    console.error(err)
                    if (mounted.current) {
                        setStatus({ success: false })
                        setErrors({ submit: err.response.data })
                        setSubmitting(false)
                    }
                }
            }}
        >
            {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                isSubmitting,
                touched,
                values,
            }): JSX.Element => (
                <form noValidate onSubmit={handleSubmit} {...props}>
                    <TextField
                        autoFocus
                        error={Boolean(touched.email && errors.email)}
                        fullWidth
                        helperText={touched.email && errors.email}
                        label="E-Mail Addresse"
                        margin="normal"
                        name="email"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        type="email"
                        value={values.email}
                        variant="outlined"
                    />
                    {errors.submit && (
                        <Box sx={{ mt: 3 }}>
                            <FormHelperText error>
                                {errors.submit}
                            </FormHelperText>
                        </Box>
                    )}
                    <Box sx={{ mt: 2 }}>
                        <Button
                            color="primary"
                            disabled={isSubmitting}
                            fullWidth
                            size="large"
                            type="submit"
                            variant="contained"
                        >
                            Passwort zurücksetzen
                        </Button>
                    </Box>
                </form>
            )}
        </Formik>
    )
}

export default PasswordRecoveryEditForm
